import { BugTracking } from "./tracking";

// Local Storage Definitions and behaviors on signout
export const entries = {
  userName: { key: "userName", shouldPersist: false },
  token: { key: "token", shouldPersist: false },
  aaaToken: { key: "aaaToken", shouldPersist: false },
  session: { key: "session", shouldPersist: false },
  // currentOrgId and currentLocationId are stored to expediate login
  currentOrgId: { key: "currentOrgId", shouldPersist: true },
  currentOrgSlug: { key: "currentOrgSlug", shouldPersist: true },
  currentLocationId: { key: "currentLocationId", shouldPersist: true },
  applicationVersion: { key: "lastApplicationVersion", shouldPersist: true },
};

type LocationIdentifiers = {
  orgId?: string;
  resolvedOrgSlug?: string;
  locationId?: string;
  userToken?: string;
  email?: string;
  session?: string;
  aaaToken?: string;
};

export function storeIdentifiers({
  orgId,
  locationId,
  userToken,
  resolvedOrgSlug,
  email,
  session,
  aaaToken,
}: LocationIdentifiers) {
  try {
    if (orgId) {
      localStorage.setItem(entries.currentOrgId.key, orgId);
    }

    if (resolvedOrgSlug) {
      localStorage.setItem(entries.currentOrgSlug.key, resolvedOrgSlug);
    }

    if (locationId) {
      localStorage.setItem(entries.currentLocationId.key, locationId);
    }

    if (userToken) {
      localStorage.setItem(entries.token.key, userToken);
    }

    if (email) {
      localStorage.setItem(entries.userName.key, email);
    }

    if (session) {
      localStorage.setItem(entries.session.key, session);
    }

    if (aaaToken) {
      localStorage.setItem(entries.aaaToken.key, aaaToken);
    }
  } catch (err) {
    BugTracking.captureException(err);
  }
}

export function getGlobalJwt(): string | undefined {
  return getStorageItem("aaaToken");
}

export function getStorageItem(key: keyof typeof entries): string | undefined {
  try {
    const storedValue = localStorage.getItem(entries[key].key);
    return typeof storedValue === "string" && storedValue.length > 0
      ? storedValue
      : void 0;
  } catch (err) {
    BugTracking.captureException(err);
    return void 0;
  }
}

export function storeApplicationVersion(version: string) {
  try {
    localStorage.setItem(entries.applicationVersion.key, version);
  } catch (err) {
    BugTracking.captureException(err);
    return void 0;
  }
}

export function storeLocation(locationId: string) {
  try {
    localStorage.setItem(entries.currentLocationId.key, locationId);
  } catch (err) {
    BugTracking.captureException(err);
  }
}

export function clearLocalStorage() {
  try {
    Object.values(entries).forEach((item) => {
      if (!item.shouldPersist) {
        localStorage.removeItem(item.key);
      }
    });
  } catch (err) {
    BugTracking.captureException(err);
  }
}

export function clearCookie() {
  try {
    document.cookie =
      "X-CLIENT-BASE=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  } catch (err) {
    BugTracking.captureException(err);
  }
}
